import { Children, FC, ReactElement, ReactNode } from "react";

const classNames = (
  ...classes: (boolean | null | string | undefined)[]
): string => {
  return classes.filter(Boolean).join(" ");
};

type TabPanelProps = {
  children: ReactNode;
  header: string;
  icon?: ReactNode;
  isLoading?: boolean;
};

export const TabPanel: FC<TabPanelProps> = ({ children }) => {
  return <div>{children}</div>;
};

interface TabViewProps {
  children: ReactElement<TabPanelProps> | ReactElement<TabPanelProps>[];
  onTabChange: (tab: string) => void;
  selectedTab: null | string;
}

// TODO: Should we unify the usage of tabs in the project?

export const TabView: FC<TabViewProps> = ({
  children,
  onTabChange,
  selectedTab,
}) => {
  const childrenArray = Children.toArray(
    children,
  ) as ReactElement<TabPanelProps>[];

  const tabList = childrenArray.map(({ props }) => ({
    icon: props.icon,
    isLoading: props.isLoading ?? false,
    tab: props.header,
  }));

  const currentTabContent = childrenArray.find(
    (n) => n.props.header === selectedTab,
  );

  return (
    <div>
      <div className="hidden sm:block">
        <nav aria-label="Tabs" className="flex space-x-4">
          {tabList.map(({ icon, isLoading, tab }) => (
            <a
              className={classNames(
                tab === selectedTab
                  ? "bg-zinc-800 text-gray-200"
                  : "text-gray-500 hover:text-gray-700",
                "flex cursor-pointer items-center space-x-2 rounded-md px-3 py-2 text-sm font-medium",
              )}
              key={tab}
              onClick={() => onTabChange(tab)}
            >
              {isLoading && (
                <svg
                  className="-ml-1 mr-3 h-5 w-5 animate-spin text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  />
                  <path
                    className="opacity-75"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    fill="currentColor"
                  />
                </svg>
              )}
              <span>{tab}</span>
              {icon && <span className="ml-2">{icon}</span>}
            </a>
          ))}
        </nav>
      </div>
      <div className="mt-4">{currentTabContent}</div>
    </div>
  );
};
